import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {BaseCompetitorArticleData, CompetitorArticleData} from "../types/competitor-article-data.types";
import {HttpClient} from "@angular/common/http";
import {baseUrl} from "../../../../../../../core/constants/base-url";
import {competitorArticlesResourceType} from "../configs/competitor-articles-modal-config";
import {RecordsDataRequestQueryParams} from "../../../../../../../core/types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class CompetitorArticlesApiService {
  private http = inject(HttpClient);
  private competitorArticleUrl = `${baseUrl}/${competitorArticlesResourceType.path}`;

  public fetchCompetitorArticlesData(queryParams: RecordsDataRequestQueryParams): Observable<Array<CompetitorArticleData>> {
    return this.http.get<Array<CompetitorArticleData>>(`${this.competitorArticleUrl}/`, {
      params: queryParams
    });
  }

  public createCompetitorArticleData(data: BaseCompetitorArticleData): Observable<CompetitorArticleData> {
    return this.http.post<CompetitorArticleData>(`${this.competitorArticleUrl}`, data);
  }

  public deleteCompetitorArticleData(id: number): Observable<void> {
    return this.http.delete<void>(`${this.competitorArticleUrl}/${id}`);
  }
}
